import type { MessageRewindTarget } from "./message-transcript.ts";

export type ChatPendingMessageEdit = {
  sessionKey: string;
  rewindTarget: MessageRewindTarget;
};

export type ChatEditRewindConfirmPayload = {
  sessionKey: string;
  rewindTarget: MessageRewindTarget;
  message: string;
  /**
   * Composer attachments restored when the operator cancels (or the
   * rewind fails). Deliberately a thin `{id, dataUrl}` snapshot.
   *
   * JAISIU-types-sweep: `mimeType` is optional because
   * `ChatAttachment.mimeType` is — an in-flight placeholder carries only
   * `dataUrl`. The restore path coalesces it with `""` downstream
   * (`mediaTypeLabel("")` renders an empty type label) and the chip
   * falls back to the generic type icon via `attachmentIconForKind`.
   */
  attachments: Array<{ id: string; dataUrl: string; mimeType?: string }>;
};

export function pendingEditMatchesSession(
  pending: ChatPendingMessageEdit | null | undefined,
  sessionKey: string,
): pending is ChatPendingMessageEdit {
  if (!pending) {
    return false;
  }
  return pending.sessionKey.trim() === sessionKey.trim();
}

export function buildChatEditRewindConfirmMessage(): string {
  return (
    "Reset the conversation from this message?\n\n" +
    "Messages and agent work after this point will be removed from the session transcript. " +
    "This cannot be undone."
  );
}
